
export interface IManufacturerState {

    getAllManufacturersSuccess : any;
    getAllManufacturersError : any;
    getAddManufacturerSuccess : any;
    getAddManufacturerError : any;
    getEditManufacturerSuccess : any;
    getEditManufacturerError : any;
    getmanufacturerBystatusIdSuccess: any;
    getmanufacturerBystatusIdError: any;
}

export const initialManufacturerState: IManufacturerState = {
    
    getAllManufacturersSuccess : null,
    getAllManufacturersError : null,
    getAddManufacturerSuccess : null,
    getAddManufacturerError : null,
    getEditManufacturerSuccess : null,
    getEditManufacturerError : null,
    getmanufacturerBystatusIdSuccess: null,
    getmanufacturerBystatusIdError:null,
}